import { createSlice } from '@reduxjs/toolkit';

export const optionsSlice = createSlice({
  name: 'options',
  initialState: {
    fluid: 'oil',
    fluids: ['oil'],
    units: 'metric',
    showChartOptions: false,
    fluidRatio: 'Off',
    chartTime: 'Relative',
    chartType: 'Rate-Time',
    showPressure: 'Hide',
    showLegend: 'Hide',
    chartOrientation: 'Horizontal',
    showTypeCurve: 'Show',
    showGroupWell: 'Show',
    showForecast: 'Show',
    showOutliers: 'Hide',
    showSidePanel: true,
    showWellListFilter: false,
    isLoadingProjectsData: true,
    isLoadingData: false,
    normalization: 'off',
    fbaTabItem: 0,
    assistedForecast: false,
    killAll: false,
    jwt: undefined,
    rtfoRequestJob: undefined,
    version: '2.12.89',
    lastUpdated: 'Apr 23, 2024'
  },
  reducers: {
    setOptions: (state, action) => {
      state = action.payload.options;
    },
    setFluid: (state, action) => {
      const fluid = action.payload.fluid;
      state.fluid = fluid;
      state.fluids = [fluid];
    },
    setFluids: (state, action) => {
      const fluids = action.payload.fluids;
      state.fluids = fluids;
    },
    setUnits: (state, action) => {
      state.units = action.payload.units;
    },
    setShowChartOptions: (state, action) => {
      state.showChartOptions = action.payload;
    },
    setFluidRatio: (state, action) => {
      state.fluidRatio = action.payload;
    },
    setChartTime: (state, action) => {
      state.chartTime = action.payload;
    },
    setChartType: (state, action) => {
      state.chartType = action.payload;
    },
    setShowPressure: (state, action) => {
      state.showPressure = action.payload;
    },
    setShowLegend: (state, action) => {
      state.showLegend = action.payload;
    },
    setChartOrientation: (state, action) => {
      state.chartOrientation = action.payload;
    },
    setShowTypeCurve: (state, action) => {
      state.showTypeCurve = action.payload;
    },
    setShowGroupWell: (state, action) => {
      state.showGroupWell = action.payload;
    },
    setShowForecast: (state, action) => {
      state.showForecast = action.payload;
    },
    setShowSidePanel: (state, action) => {
      state.showSidePanel = action.payload;
    },
    setShowOutliers: (state, action) => {
      state.showOutliers = action.payload;
    },
    setShowWellListFilter: (state, action) => {
      state.showWellListFilter = action.payload;
    },
    setIsLoadingProjectsData: (state, action) => {
      state.isLoadingProjectsData = action.payload;
    },
    setIsLoadingData: (state, action) => {
      state.isLoadingData = action.payload;
    },
    setNormalization: (state, action) => {
      state.normalization = action.payload;
    },
    setFbaTabItem: (state, action) => {
      state.fbaTabItem = action.payload;
    },
    setJwt: (state, action) => {
      state.jwt = action.payload;
    },
    setKillAll: (state, action) => {
      state.killAll = action.payload;
    },
    toggleAssistedForecast: (state, action) => {
      state.assistedForecast = !state.assistedForecast;
    }
  }
});

export const { 
  setOptions,
  setFluid,
  setFluids,
  setUnits, 
  setShowChartOptions,
  setFluidRatio,
  setChartTime,
  setChartType,
  setShowLegend,
  setShowPressure,
  setChartOrientation,
  setShowTypeCurve,
  setShowGroupWell,
  setShowForecast,
  setShowOutliers,
  setShowSidePanel,
  setShowWellListFilter,
  setIsLoadingProjectsData,
  setIsLoadingData,
  setNormalization,
  setFbaTabItem,
  setJwt,
  setKillAll,
  toggleAssistedForecast
} = optionsSlice.actions;

export const selectOptions = (state) => state.options;

export default optionsSlice.reducer;